export default __webpack_public_path__ + "static/frank-liszt-7c0615866bb05d8d94baef71b76f22b7.jpg";